<template>
  <div class="personal-tax" style="width: 100vw">
    <SubCard :title="`${$t('personal_tax_per_year')}`">
      <PersonalTaxPerYear />
    </SubCard>
    <br />
    <SubCard :title="`${$t('personal_tax_per_year_non_chinese')}`">
      <PersonalTaxPerYearNonChinese />
    </SubCard>
    <br />
    <SubCard :title="`${$t('personal_tax_company')}`">
      <PersonalTaxCompany />
    </SubCard>
    <br />
    <SubCard :title="`${$t('personal_tax_other')}`">
      <PersonalTaxOther />
    </SubCard>

    <br />
    <div class="column is-full">
      {{ $t("disclaimer_GBP_1") }}
    </div>
    <div class="column is-full">
      {{ $t("disclaimer_GBP_2") }}
    </div>
    <div class="column is-full">
      {{ $t("disclaimer_GBP_3") }}
    </div>
  </div>
</template>

<script>
import PersonalTaxPerYear from "./PersonalTaxPerYear.vue";
import PersonalTaxPerYearNonChinese from "./PersonalTaxPerYearNonChinese.vue";
import PersonalTaxCompany from "./PersonalTaxCompany.vue";
import PersonalTaxOther from "./PersonalTaxOther.vue";
import SubCard from "@/components/SubCard.vue";

export default {
  components: {
    PersonalTaxPerYear,
    PersonalTaxPerYearNonChinese,
    PersonalTaxCompany,
    PersonalTaxOther,
    SubCard,
  },
};
</script>
